import CryptoJS from "crypto-js";
import {SECRET_KEY} from 'store/constant';

// Encrypt function
const encryptData = (data) => {
  try {
    const stringData = JSON.stringify(data);
    return CryptoJS.AES.encrypt(stringData, SECRET_KEY).toString();
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};

// Decrypt function
const decryptData = (cipherText) => {
  try {
    if (!cipherText) return null;
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

class SecureStorage {
  constructor(storageType = "localStorage") {
    this.storage =
      storageType === "sessionStorage" ? sessionStorage : localStorage;
  }

  set(key, value) {
    const encrypted = encryptData(value);
    if (encrypted) this.storage.setItem(key, encrypted);
  }

  get(key) {
    const encrypted = this.storage.getItem(key);
    return decryptData(encrypted);
  }

  remove(key) {
    this.storage.removeItem(key);
  }

  clear() {
    this.storage.clear();
  }
}

// Export ready-to-use instances
export const secureLocalStorage = new SecureStorage("localStorage");
export const secureSessionStorage = new SecureStorage("sessionStorage");
